export default {"src":"/_next/static/media/fences.e1fe8ad8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};